import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { CampaignStep } from '../campaign-step';
import { Campaign } from '../campaign';
import { CampaignStoresComponent } from './stores/campaign-stores.component';
import { CampaignSegmentsComponent } from './segments/campaign-segments.component';
import { CampaignCouponsComponent } from './coupons/campaign-coupons.component';


@Component({
  selector: 'campaign-step-4',
  templateUrl: 'campaign-step-4.html',
})
export class CampaignStep4Component implements CampaignStep
{
  @ViewChild(CampaignStoresComponent) stores: CampaignStoresComponent;
  @ViewChild(CampaignCouponsComponent) coupons: CampaignCouponsComponent;
  @ViewChild(CampaignSegmentsComponent) segments: CampaignSegmentsComponent;
  @Input() campaign: Campaign;
  @Input() returnedSavedCategories: any[];
  @Input() returnedSavedProductCouponsF: any[];
  @Input() returnedSavedProductCouponsNF: any[];
  @Input() targetedStores: string;

  @Output() savedSelectedCategories: EventEmitter<any[]> = new EventEmitter();
  @Output() savedSelectedProductCouponsF: EventEmitter<any[]> = new EventEmitter();
  @Output() savedSelectedProductCouponsNF: EventEmitter<any[]> = new EventEmitter();

  public panel: number = 1;
  private savedCategories: any[] = [];
  private savedProductCouponsF: any[] = [];
  private savedProductCouponsNF: any[] = [];


  constructor() {

  }

  ngOnInit()
  {

  }

  setPanel(panel)
  {
    this.panel = panel;
  }

  public generateCoupons(fn?)
  {
    fn ? this.coupons.checkAllCoupons(fn) : this.coupons.checkAllCoupons();
  }

  public isStepCompleted()
  {
    if(typeof this.campaign.stores === 'undefined' || typeof this.campaign.segments === 'undefined') {
      return false;
    }

    return (
      this.campaign.stores.length > 0 &&
      this.campaign.segments.length > 0
    );
  }

  saveSelectedCategories(event) {
    this.savedCategories = event;
    this.savedSelectedCategories.emit(event);
  }

  saveSelectedProductCouponsF(event) {
    this.savedProductCouponsF = event;
    this.savedSelectedProductCouponsF.emit(event);
  }

  saveSelectedProductCouponsNF(event) {
    this.savedProductCouponsNF = event;
    this.savedSelectedProductCouponsNF.emit(event);
  }

  returnSavedCategories(event) {
    this.returnedSavedCategories = event;
  }

  returnSavedProductCouponsF(event) {
    this.returnedSavedProductCouponsF = event;
  }

  returnSavedProductCouponsNF(event) {
    this.returnedSavedProductCouponsNF = event;
  }

  updateTargetedStores(event) {
    this.targetedStores = event;
  }

  saveCampaignAndExit() {
    return new Promise((resolve, reject) => {
      this.coupons.saveCampaignAndExit()
      .then(() => resolve())
      .catch(() => reject())
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/campaign-step-4.component.ts